const Baus = 'Baus';

export const FETCH_INTERNAL_METRICS_REQUEST = `${Baus}/FETCH_INTERNAL_METRICS_REQUEST`;
export const FETCH_INTERNAL_METRICS_ERROR = `${Baus}/FETCH_INTERNAL_METRICS_ERROR`;
export const RECEIVED_INTERNAL_METRICS = `${Baus}/RECEIVED_INTERNAL_METRICS`;

export const FETCH_USERS_REQUEST = `${Baus}/FETCH_USERS_REQUEST`;
export const FETCH_USERS_ERROR = `${Baus}/FETCH_USERS_ERROR`;
export const RECEIVED_USERS = `${Baus}/RECEIVED_USERS`;

export const FETCH_METRICS_BY_ORGANIZATION_REQUEST = `${Baus}/FETCH_METRICS_BY_ORGANIZATION_REQUEST`;
export const FETCH_METRICS_BY_ORGANIZATION_ERROR = `${Baus}/FETCH_METRICS_BY_ORGANIZATION_ERROR`;
export const RECEIVED_ORGANIZATION_METRICS = `${Baus}/RECEIVED_ORGANIZATION_METRICS`;
